import { createRoute, useNavigate, useSearch } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { EmailCampaignManager } from "@/features/admin/components/email-campaign-manager";
import { PageContainer } from "@fleet/ui";

interface AdminEmailCampaignsSearch {
  /** Opens the "new campaign" form (`?new=1`). */
  new?: boolean;
}

function AdminEmailCampaignsPage() {
  const search = useSearch({ from: "/_app/admin/email/campaigns" });
  const navigate = useNavigate();

  // The "new campaign" form is deep-linkable (`?new=1`): the URL is the
  // source of truth for opening/closing.
  const setCreating = (open: boolean): void => {
    if (open === Boolean(search().new)) {
      return;
    }
    void navigate({
      to: "/admin/email/campaigns",
      search: open ? { new: true } : {},
      replace: true,
    });
  };

  return (
    <PageContainer maxWidth="6xl">
      <EmailCampaignManager creating={Boolean(search().new)} onCreatingChange={setCreating} />
    </PageContainer>
  );
}

export const adminEmailCampaignsRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/email/campaigns",
  validateSearch: (search: Record<string, unknown>): AdminEmailCampaignsSearch => ({
    // Includes the NUMBER 1: TanStack auto-parses `?new=1` as number 1 (not string);
    // without this case the param was discarded at boot and the dialog did not open via
    // deep link (CC-18).
    new:
      search.new === true || search.new === 1 || search.new === "1" || search.new === "true"
        ? true
        : undefined,
  }),
  component: AdminEmailCampaignsPage,
});
